const getLocalizedString = (localizedStrings, locale) => {
  let value = localizedStrings?.find((string) => string.locale === locale)?.value;
  if (value === void 0) {
    value = localizedStrings?.find((string) => string.locale.substr(0, 2) === "en")?.value;
  }
  return value || "";
};
const getLocalizedStrings = (localizedStrings, locale) => {
  let values = localizedStrings?.find((string) => string.locale === locale)?.values;
  if (values === void 0) {
    values = localizedStrings?.find((string) => string.locale.substr(0, 2) === "en")?.values;
  }
  return values || [];
};
export {
  getLocalizedString,
  getLocalizedStrings
};
//# sourceMappingURL=get-localized-string.js.map
